const T_PREFIX = "auth.registration";

export const registrationButtonsTrns = {
  stepButton: `${T_PREFIX}.step-btn`,
  nextButton: `${T_PREFIX}.next-btn`,
  prevButton: `${T_PREFIX}.prev-btn`,
  submitButton: `${T_PREFIX}.submit-btn`,
  toMainPage: `${T_PREFIX}.to-main-page-btn`,
};

export const registrationTitlesTrns = {
  youRegisteringAs: `${T_PREFIX}.titles.you-registering-as`,
  countryOfRegistration: `${T_PREFIX}.titles.country-of-registration`,
  companyInfo: `${T_PREFIX}.titles.company-info`,
  responsiblePerson: `${T_PREFIX}.titles.responsible-person`,
  briefInfo: `${T_PREFIX}.titles.brief-info`,
  chooseYourIndustry: `${T_PREFIX}.titles.choose-your-industry`,
  internationalMarket: `${T_PREFIX}.titles.international-market`,
  countriesOfRepresentation: `${T_PREFIX}.titles.countries-of-representation`,
  createYourPassword: `${T_PREFIX}.titles.create-your-password`,
  uploadFoundingDocuments: `${T_PREFIX}.titles.upload-founding-documents`,
  loggingInData: `${T_PREFIX}.titles.logging-in-data`,
  accountCreated: `${T_PREFIX}.titles.account-created`,
};

export const registrationDescriptionsTrns = {
  registeringAsOwner: `${T_PREFIX}.descriptions.owner-role`,
  registeringAsBroker: `${T_PREFIX}.descriptions.agent-role`,
  internationalMarketDesc: `${T_PREFIX}.descriptions.international-market`,
  accountCreatedDesc: `${T_PREFIX}.descriptions.account-created`,
};

// CHANGE - temp
export const registrationOptionstTrns = {
  yes: `${T_PREFIX}.options.yes-label`,
  no: `${T_PREFIX}.options.no-label`,

  businessOwner: `${T_PREFIX}.options.business-owner-label`,
  agent: `${T_PREFIX}.options.agent-label`,
};
